"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.classes = exports.rootNodePath = void 0;
var rootNodePath = '/*';
exports.rootNodePath = rootNodePath;
var classes = {
  stepperMainContainer: 'policy-general-tab-main-container',
  addPolicyFieldWrapper: 'sm-add-policy-field-wrapper',
  formNameLoaderWrapper: 'sm-form-name-loader-wrapper',
  formNameCheckLoader: 'sm-form-name-check-loader',
  addPolicyFieldValueWrapper: 'sm-add-policy-field-value-wrapper'
};
exports.classes = classes;